import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en_US from "@/locales/en_US/battery_graph";
import zh_CN from "@/locales/zh_CN/battery_graph";
import zh_HK from "@/locales/zh_HK/battery_graph";
import zh_TW from "@/locales/zh_TW/battery_graph";
import ug_CN from "@/locales/ug_CN/battery_graph";
import bo_CN from "@/locales/bo_CN/battery_graph";
import ko_KR from "@/locales/ko_KR/battery_graph";
import ja_JP from "@/locales/ja_JP/battery_graph";
import fr_FR from "@/locales/fr_FR/battery_graph";
import es_ES from "@/locales/es_ES/battery_graph";
import es_US from "@/locales/es_US/battery_graph";
import de_DE from "@/locales/de_DE/battery_graph";
import ar_EG from "@/locales/ar_EG/battery_graph";
import th_TH from "@/locales/th_TH/battery_graph";
import pt_BR from "@/locales/pt_BR/battery_graph";
import pt_PT from "@/locales/pt_PT/battery_graph";

const resources = {
  en_US: {
    translation: en_US
  },
  zh_CN: {
    translation: zh_CN
  },
  zh_HK: {
    translation: zh_HK
  },
  zh_TW: {
    translation: zh_TW
  },
  ug_CN: {
    translation: ug_CN
  },
  bo_CN: {
    translation: bo_CN
  },
  ko_KR: {
    translation: ko_KR
  },
  ja_JP: {
    translation: ja_JP
  },
  fr_FR: {
    translation: fr_FR
  },
  es_ES: {
    translation: es_ES
  },
  es_US: {
    translation: es_US
  },
  de_DE: {
    translation: de_DE
  },
  ar_EG: {
    translation: ar_EG
  },
  th_TH: {
    translation: th_TH
  },
  pt_BR: {
    translation: pt_BR
  },
  pt_PT: {
    translation: pt_PT
  }
};

const SUPPORTED_LNGS = [
  "zh_CN",
  "en_US",
  "zh_HK",
  "zh_TW",
  "ug_CN",
  "bo_CN",
  "ko_KR",
  "ja_JP",
  "fr_FR",
  "es_ES",
  "es_US",
  "de_DE",
  "ar_EG",
  "th_TH",
  "pt_BR",
  "pt_PT"
];

i18n
  .use(initReactI18next)
  .init({
    resources,
    // lng: "cimode",
    fallbackLng: false,
    // debug: true,
    supportedLngs: SUPPORTED_LNGS,
    preload: true,
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    }
    // react: {
    //   wait: true,
    //   useSuspense: false
    // }
  });

export default i18n;

export const setLang = params => {
  if (!params) {
    return "zh_CN";
  }
  // 系统传入的 ar_EG_#u-nu- 是阿拉伯语 + 西阿拉伯数字变体,
  // 文件路径不允许出现 # 字符,统一回落到 ar_EG 共用同一份翻译
  if (params.startsWith("ar_EG")) {
    return "ar_EG";
  }
  if (SUPPORTED_LNGS.includes(params)) {
    return params;
  }
  return "zh_CN";
};
